<template>
	<section class="h-auto rounded-md p-3" :class="color === 'green' ? 'bg-gradient-green' : 'bg-gradient-red'">
		<div class="flex flex-col gap-2 w-full lg:w-auto justify-around text-white">
			<div class="text-xl uppercase">
				{{ title }}
			</div>
			<div class="text-xl font-bold text-white">
				<span>{{ message }}</span>
			</div>
		</div>
	</section>
</template>

<script setup>
	const props = defineProps({
		title: {
			type: String,
			default: '',
		},
		message: {
			type: String,
			default: 'Indisponible',
		},
		color: {
			type: String,
			default: 'green',
			validator: (value) => ['green', 'red'].includes(value),
		},
	});
</script>
